export const TOP_COUNTRIES_OPTION = 'countries';
export const TOP_LANGUAGES_OPTION = 'languages';

export const BY_MOST_LIKES_VALUE = 'BY_MOST_LIKES';
export const BY_MOST_SHARES_VALUE = 'BY_MOST_SHARES';
export const BY_MOST_COMMENTS_VALUE = 'BY_MOST_COMMENTS';
export const BY_MOST_FOLLOWERS_VALUE = 'BY_MOST_FOLLOWERS';
export const BY_TOTAL_ENGAGEMENT_VALUE = 'counts.total_engagements';
export const BY_TOTAL_REACH_VALUE = 'counts.reach_score';

// @NOTE as discussed with Itamar e.g. Topics widget can fetch like 100 items in single request as it's highly doubtful that there will be more and that way we will be able to handle sort at FE among all pages
export const COMMON_RESPONSE_LIMIT = 100;
